import type { Page } from '@/domain/model/Page';
import type { SolicitacaoDescontoExtra, DecidirDescontoExtraCommand } from '@/domain/model/SolicitacaoDescontoExtra';
import type { SolicitacaoDescontoExtraGateway, ListSolicitacoesDescontoExtraParams } from '@/application/port/out/SolicitacaoDescontoExtraGateway';
import type {
  ListSolicitacoesDescontoExtraUseCase, DecidirDescontoExtraUseCase,
} from '@/application/port/in/SolicitacaoDescontoExtraUseCase';

export class ListSolicitacoesDescontoExtra implements ListSolicitacoesDescontoExtraUseCase {
  constructor(private readonly g: SolicitacaoDescontoExtraGateway) {}
  execute(params: ListSolicitacoesDescontoExtraParams): Promise<Page<SolicitacaoDescontoExtra>> { return this.g.list(params); }
}
export class DecidirDescontoExtra implements DecidirDescontoExtraUseCase {
  constructor(private readonly g: SolicitacaoDescontoExtraGateway) {}
  execute(id: string, cmd: DecidirDescontoExtraCommand): Promise<SolicitacaoDescontoExtra> { return this.g.decidir(id, cmd); }
}
